import React from 'react'
import { Container, Heading } from './styles'
import Paper from 'material-ui/Paper'
import IconButton from 'material-ui/IconButton'
import ArrowBack from 'material-ui/svg-icons/navigation/arrow-back'
import { FormattedMessage } from 'react-intl'
import { Link } from 'react-router-dom'
import FooterMenu from '../../components/FooterMenu'
import SignupForm from '../../components/SignUpForm'
import SignupComplete from '../../components/SignupComplete'

const Register = ({
    signupUser,
    signupStatus,
    user,
    hasErrorOccured,
    errors,
    recieveSignupstatus,
    ...props
  }) => (
  <div className="flex justify-center flex-column items-center h-100">
    <Container>
      <Paper zDepth={3}>
        <div className="pa3">
          <div className="flex justify-between mb2">
            <Link
              to={'/'}
            >
              <IconButton>
                <ArrowBack color="#afb8c5"/>
              </IconButton>
            </Link>
            <Heading className="flex items-center pr1">
              {!signupStatus ? (
                <FormattedMessage id="signUp.heading"/>
              ) : (
                <FormattedMessage id="signUp.doneHeading"/>
              )}
            </Heading>
            <div className="w-10"/>
          </div>
          {!signupStatus ? (
            <SignupForm
              {...props}
              errors={errors}
              user={user}
              signupUser={signupUser}
              authErrors={props.authErrors}
            />
          ) : (
            <SignupComplete
              location={props.location.pathname}
              recieveSignupstatus={recieveSignupstatus}
              user={user}
            />
          )}
        </div>
      </Paper>
      <FooterMenu/>
    </Container>
  </div>
)

export default Register



// WEBPACK FOOTER //
// ./src/routes/SignUp/SignUp.js